var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .065)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#5C5C5C",
    width: 50,
    height: 50,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.38 40c-.209 0-.416-.062-.593-.187C24.346 39.504 14 32.139 14 21.379 14 15.105 19.105 10 25.38 10c6.273 0 11.379 5.105 11.379 11.38 0 10.759-10.346 18.124-10.787 18.433a1.027 1.027 0 0 1-.593.187zm0-27.931c-5.134 0-9.311 4.177-9.311 9.31 0 8.272 7.172 14.589 9.31 16.287 2.138-1.698 9.31-8.015 9.31-16.287 0-5.133-4.176-9.31-9.31-9.31zm0 14.483a5.178 5.178 0 0 1-5.173-5.173 5.178 5.178 0 0 1 5.172-5.172 5.178 5.178 0 0 1 5.173 5.172 5.178 5.178 0 0 1-5.173 5.173zm0-8.276a3.107 3.107 0 0 0-3.104 3.103 3.107 3.107 0 0 0 3.103 3.104 3.107 3.107 0 0 0 3.104-3.104 3.107 3.107 0 0 0-3.104-3.103z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.0e94b7fe20ff29697d0914af0ae5fd17.svg";
export { ForwardRef as ReactComponent };